// ============================================
// Google Maps Ads - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleMapsAdsContent: BlogContent = {
  tableOfContents: [
    { id: "maps-ads-nedir", title: "Google Maps Ads Nedir?" },
    { id: "kampanya-turleri", title: "Kampanya Türleri" },
    { id: "sektorel-stratejiler", title: "Sektörel Stratejiler" },
    { id: "basari-metrikleri", title: "Başarı Metrikleri" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads</strong>, yerel işletmelerin potansiyel müşterilere en doğru zamanda ve konumda ulaşmasını sağlayan güçlü bir reklam platformudur. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> Google Maps reklamlarının yerel işletmelere %400-600 oranında daha fazla fiziksel ziyaret sağladığını gözlemledim. Bu rehberde, Google Maps Ads kampanya türlerini, sektörel stratejileri ve ölçülebilir başarı metriklerini detaylıca paylaşacağım."
    },
    {
      type: "heading",
      value: "Google Maps Ads Nedir?",
      id: "maps-ads-nedir"
    },
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads</strong>, kullanıcılar Google Haritalar uygulamasında veya Google Arama'da yerel aramalar yaptığında işletmenizin öne çıkmasını sağlayan ücretli reklam formatıdır. Kullanıcılar 'yakınımdaki kafe', '[şehir] kuaför', 'acil tesisatçı' gibi aramalar yaptığında, harita üzerinde işletmeniz sponsored (sponsorlu) etiketiyle vurgulanır."
    },
    {
      type: "paragraph",
      value: "Google Maps Ads'in temel özellikleri:"
    },
    {
      type: "list",
      items: [
        "<strong>Harita Üzerinde Görünürlük:</strong> İşletmeniz haritada özel bir pin işareti ve 'Sponsored' etiketi ile gösterilir.",
        "<strong>Konum Tabanlı Hedefleme:</strong> İşletmenize fiziksel olarak yakın kullanıcılara reklam gösterirsiniz.",
        "<strong>Niyetli Kullanıcılar:</strong> Zaten bir şey arayan, satın almaya hazır kullanıcılara ulaşırsınız.",
        "<strong>Tıklama veya Arama Başına Ödeme:</strong> Sadece kullanıcı reklamınızı tıkladığında, telefon aradığında veya yol tarifi aldığında ödeme yaparsınız.",
        "<strong>Yerel SEO Entegrasyonu:</strong> Google İşletme Profili optimize edildiğinde, reklam performansınız %30-40 artar."
      ]
    },
    {
      type: "paragraph",
      value: "Google'ın verilerine göre, yerel niyetli aramaların %76'sı 24 saat içinde fiziksel mağaza ziyaretiyle sonuçlanıyor. Google Maps Ads, bu yüksek niyetli trafiği yakalamak için ideal bir kanaldır."
    },
    {
      type: "heading",
      value: "Kampanya Türleri",
      id: "kampanya-turleri"
    },
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads kampanya türleri</strong>, farklı iş hedeflerine ve sektörlere göre optimize edilmiştir:"
    },
    {
      type: "subheading",
      value: "1. Local Search Ads (Promoted Pins)"
    },
    {
      type: "paragraph",
      value: "En yaygın kullanılan Google Maps reklam formatı, haritada işletmenizi öne çıkarır:"
    },
    {
      type: "list",
      items: [
        "<strong>Çalışma Prensibi:</strong> Kullanıcı 'yakınımdaki restoran' aradığında, reklamınız harita üzerinde mor/kırmızı renkli pin ile gösterilir.",
        "<strong>Maliyet Modeli:</strong> CPC (Cost Per Click) - Kullanıcı pin'e tıkladığında, telefon aradığında veya yol tarifi aldığında ücret ödersiniz.",
        "<strong>Ortalama CPC:</strong> İstanbul'da 3-12 TL arası, sektöre ve rekabete göre değişir.",
        "<strong>En Uygun İçin:</strong> Tüm yerel işletmeler, özellikle yüksek footfall (yaya trafiği) gerektiren restoranlar, mağazalar, hizmet sağlayıcılar.",
        "<strong>Dönüşüm Oranı:</strong> Deneyimime göre %30-50 arasında, kullanıcılar zaten harita üzerinde arama yaptığı için niyetleri çok yüksektir."
      ]
    },
    {
      type: "subheading",
      value: "2. Local Campaigns"
    },
    {
      type: "paragraph",
      value: "Google'ın AI destekli, otomatik optimize edilen multi-channel kampanya türüdür:"
    },
    {
      type: "list",
      items: [
        "<strong>Platform Kapsama:</strong> Google Haritalar, Google Arama, Display Network, YouTube ve Gmail'de otomatik yayın.",
        "<strong>Otomasyonlu İzleme:</strong> Google'ın makine öğrenmesi en iyi performans gösteren kanalları, saatleri ve cihazları otomatik bulur.",
        "<strong>Store Visits Hedefi:</strong> Kampanya doğrudan 'mağaza ziyareti artırma' hedefine optimize edilir.",
        "<strong>Kolay Kurulum:</strong> Sadece bütçe, lokasyon ve reklam metni belirlemeniz yeterli, Google gerisini halleder.",
        "<strong>Performans:</strong> Manuel kampanyalara göre %20-30 daha düşük CPA (Cost Per Action), %25 daha fazla mağaza ziyareti.",
        "<strong>Minimum Bütçe:</strong> Günlük 200 TL ile başlayabilirsiniz."
      ]
    },
    {
      type: "subheading",
      value: "3. Performance Max for Store Goals"
    },
    {
      type: "paragraph",
      value: "Google'ın en gelişmiş AI tabanlı kampanya türü, fiziksel mağaza hedeflerine özel:"
    },
    {
      type: "list",
      items: [
        "<strong>AI-Powered Optimizasyon:</strong> Google'ın tüm envanterine (Arama, Haritalar, YouTube, Display, Discover, Gmail) erişim ve otomatik optimizasyon.",
        "<strong>Store Visits Measurement:</strong> Fiziksel mağaza ziyaretlerini Google Location History verileri ile ölçer.",
        "<strong>Asset Group Stratejisi:</strong> Metin, görsel, video gibi farklı reklam formatlarını otomatik oluşturur ve en iyisini bulur.",
        "<strong>Audience Signals:</strong> İdeal müşteri profilinizi tanımlayarak, Google benzer kullanıcıları bulur.",
        "<strong>ROI:</strong> 18 yıllık deneyimime göre, geleneksel Local kampanyalardan %35-50 daha yüksek ROI.",
        "<strong>Önerilen Bütçe:</strong> Günlük 500 TL+, düşük bütçelerde AI yeteri kadar veri toplayamaz."
      ]
    },
    {
      type: "subheading",
      value: "4. Search Ads with Location Extensions"
    },
    {
      type: "paragraph",
      value: "Klasik Google Arama reklamlarına konum uzantısı ekleyerek harita görünürlüğü kazanırsınız:"
    },
    {
      type: "list",
      items: [
        "<strong>Hybrid Yaklaşım:</strong> Hem arama sonuçlarında metin reklam, hem de haritada pin gösterimi.",
        "<strong>Çift Dönüşüm Fırsatı:</strong> Kullanıcı web sitenize gidebilir veya haritadan yol tarifi alabilir.",
        "<strong>Daha Geniş Kapsam:</strong> Pure Maps Ads'e göre daha fazla arama terimi hedefleyebilirsiniz.",
        "<strong>Maliyet:</strong> Standart arama reklamlarıyla aynı, ek maliyet yok.",
        "<strong>En Uygun İçin:</strong> E-ticaret + fiziksel mağaza kombinasyonu olan işletmeler."
      ]
    },
    {
      type: "heading",
      value: "Sektörel Stratejiler",
      id: "sektorel-stratejiler"
    },
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads sektörel stratejileri</strong>, her sektörün benzersiz müşteri davranışlarına göre özelleştirilmelidir. İşte <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> dayalı sektör özel stratejiler:"
    },
    {
      type: "subheading",
      value: "Restoran, Kafe, Fast Food"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads + Local Campaigns.",
        "<strong>Hedefleme Stratejisi:</strong> 5 km yarıçap, öğle (11:00-14:00) ve akşam (18:00-22:00) saatleri öncelikli.",
        "<strong>Anahtar Kelimeler:</strong> 'yakınımdaki restoran', '[mutfak türü] [şehir]', 'açık restoranlar', 'kahvaltı mekanları'.",
        "<strong>Dayparting:</strong> Kahvaltı mekanları 07:00-11:00, öğle yemeği 11:00-14:00, akşam yemeği 18:00-22:00'de teklif %40 artırın.",
        "<strong>Reklam Uzantıları:</strong> Menü linki, online sipariş (Yemeksepeti entegrasyonu), rezervasyon, telefon araması.",
        "<strong>Görsel Strateji:</strong> Yemek fotoğrafları, ambiyans görselleri, müşteri yorumlarından alıntılar.",
        "<strong>Sezonsal Kampanyalar:</strong> Ramazan, Sevgililer Günü, Anneler Günü'nde özel menü reklamları.",
        "<strong>Bütçe:</strong> İstanbul'da günlük 250-600 TL, küçük şehirlerde 100-250 TL.",
        "<strong>Başarı Metrikleri:</strong> Telefon aramaları, rezervasyonlar, yol tarifi tıklamaları, online sipariş sayısı."
      ]
    },
    {
      type: "subheading",
      value: "Sağlık (Diş, Klinik, Estetik, Psikoloji)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads (yüksek niyetli aramalar).",
        "<strong>Hedefleme:</strong> 10-20 km yarıçap (sağlık için kullanıcılar daha uzağa gidebilir), iş saatleri 09:00-18:00.",
        "<strong>Anahtar Kelimeler:</strong> '[şehir] diş kliniği', 'acil diş ağrısı', '[şehir] psikolog randevu', 'estetik cerrahi [şehir]'.",
        "<strong>Yasal Uyum:</strong> Sağlık Bakanlığı reklam yönetmeliğine uygun reklam metni (öncesi-sonrası fotoğraf yasak).",
        "<strong>Trust Signals:</strong> Doktor CV'leri, sertifikalar, tedavi süresi, hasta yorumları.",
        "<strong>Landing Page:</strong> Online randevu formu (entegre), ücretsiz ön değerlendirme teklifi.",
        "<strong>Call Extensions:</strong> Telefon araması öncelikli (sağlıkta dönüşümlerin %70'i telefon).",
        "<strong>Bütçe:</strong> İstanbul'da günlük 400-1000 TL, CPC 10-30 TL (yüksek rekabet).",
        "<strong>ROI Hesaplama:</strong> Ortalama tedavi değeri 2000-10000 TL, CPA 150-400 TL, ROI 5x-20x."
      ]
    },
    {
      type: "subheading",
      value: "Otomotiv (Servis, Lastik, Yedek Parça)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Performance Max for Store Goals + Local Search Ads.",
        "<strong>Hedefleme:</strong> Araç sahipleri (in-market audience), 15 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> '[şehir] oto servis', 'araç periyodik bakım', 'lastik değişimi [şehir]', 'yedek parça [marka]'.",
        "<strong>Sezonsal Fırsatlar:</strong> Kış lastiği dönemi (Ekim-Aralık) bütçe %50 artış, yaz bakım sezonu (Nisan-Mayıs).",
        "<strong>Remarketing:</strong> Servis randevusu almadan ayrılan kullanıcılara harita reklamı gösterin.",
        "<strong>Video Stratejisi:</strong> YouTube'da servis içi işlem videoları, müşteri güvenini artırır.",
        "<strong>Bütçe:</strong> Günlük 300-700 TL, sezonlarda %50 artış.",
        "<strong>Başarı Metrikleri:</strong> Randevu rezervasyonları, telefon aramaları, yol tarifi tıklamaları."
      ]
    },
    {
      type: "subheading",
      value: "Güzellik & SPA (Kuaför, Cilt Bakım, Masaj)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Campaigns (multi-channel erişim).",
        "<strong>Hedefleme:</strong> Kadın kullanıcılar %75-85, 25-50 yaş arası, 8 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> '[şehir] kuaför randevu', 'cilt bakımı [ilçe]', 'spa masaj merkezi', 'gelin saçı [şehir]'.",
        "<strong>Görsel Pazarlama:</strong> Öncesi-sonrası saç fotoğrafları, salon iç mekan, ürün kullanımı.",
        "<strong>Appointment Integration:</strong> Google rezervasyon sistemi entegrasyonu (dönüşüm oranını %40 artırır).",
        "<strong>Özel Günler:</strong> 14 Şubat, Anneler Günü, Ramazan Bayramı öncesi bütçe %60 artış.",
        "<strong>Paket Satışı:</strong> 'İlk randevuya %20 indirim', '3 seans paket fiyatı' gibi teklifler.",
        "<strong>Bütçe:</strong> Günlük 200-500 TL.",
        "<strong>Remarketing:</strong> Rezervasyon yapmadan ayrılanlara %10 indirim kodu."
      ]
    },
    {
      type: "subheading",
      value: "Ev Hizmetleri (Tesisatçı, Elektrikçi, Temizlik)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads + Call-Only Ads.",
        "<strong>Hedefleme:</strong> Acil durumlar için 7/24 reklam yayını, 25 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> 'acil tesisatçı', '24 saat elektrikçi [şehir]', 'su kaçağı tamiri', 'petek temizliği'.",
        "<strong>Telefon Önceliği:</strong> Ev hizmetlerinde dönüşümlerin %85'i telefon aramasıdır, web sitesi ziyareti önemsiz.",
        "<strong>Dayparting:</strong> Gece 22:00-08:00 arası 'acil' aramaları için teklif %60 artırın.",
        "<strong>Trust Building:</strong> 'Sigortalı personel', '15 yıl deneyim', 'fatura garantisi' gibi trust signals.",
        "<strong>Bütçe:</strong> Günlük 150-400 TL, hafta içi daha yüksek (iş günleri arızalar daha fazla).",
        "<strong>ROI:</strong> Telefon araması başına 8-15 TL maliyet, ortalama iş değeri 500-3000 TL."
      ]
    },
    {
      type: "heading",
      value: "Başarı Metrikleri",
      id: "basari-metrikleri"
    },
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads başarı metrikleri</strong>, sektörünüze ve kampanya hedeflerinize göre farklılık gösterir. İşte takip etmeniz gereken kritik metrikler:"
    },
    {
      type: "subheading",
      value: "Temel Performans Metrikleri (KPI'lar)"
    },
    {
      type: "table",
      caption: "Google Maps Ads Temel Metrikler",
      headers: ["Metrik", "Tanım", "Benchmark (İyi)", "Ölçüm Yöntemi"],
      rows: [
        ["Clicks to Directions", "Yol tarifi tıklama sayısı", "%15-25", "Google Ads raporu"],
        ["Clicks to Call", "Telefon araması sayısı", "%10-20", "Call reporting"],
        ["Store Visits", "Fiziksel mağaza ziyareti", "Tıklamanın %30-50'si", "Google Location Services"],
        ["CTR (Click-Through Rate)", "Gösterim başına tıklama oranı", "%5-12", "Google Ads dashboard"],
        ["CPC (Cost Per Click)", "Tıklama başına maliyet", "Sektöre göre 3-25 TL", "Google Ads billing"],
        ["Conversion Rate", "Dönüşüm oranı", "%30-60", "Conversion tracking"]
      ]
    },
    {
      type: "subheading",
      value: "İleri Düzey Analiz Metrikleri"
    },
    {
      type: "list",
      items: [
        "<strong>Cost Per Store Visit (CPSV):</strong> Mağaza ziyareti başına maliyet. İdeal: 15-40 TL arası (sektöre göre).",
        "<strong>Store Visit Rate:</strong> Reklamı tıklayan kullanıcıların kaçı fiziksel mağazaya geldi. İyi: %30-50.",
        "<strong>Return on Ad Spend (ROAS):</strong> Harcanan 1 TL'nin kaç TL gelir getirdiği. Minimum: 3x, iyi: 5x-10x.",
        "<strong>Appointment Rate:</strong> Telefon arayanların veya web sitesini ziyaret edenlerin kaçı randevu aldı. İyi: %40-60.",
        "<strong>New vs Returning Customers:</strong> Yeni müşteri kazanma oranı. Hedef: %60-70 yeni müşteri.",
        "<strong>Lifetime Value (LTV):</strong> Reklamdan gelen bir müşterinin toplam yaşam boyu değeri. Hesaplama: Ortalama satış x tekrar alım oranı."
      ]
    },
    {
      type: "subheading",
      value: "Google Ads Raporlama Araçları"
    },
    {
      type: "paragraph",
      value: "Bu metrikleri doğru ölçmek için Google'ın şu araçlarını kullanın:"
    },
    {
      type: "list",
      items: [
        "<strong>Google Ads Dashboard:</strong> Temel metrikler (clicks, CTR, CPC, impressions).",
        "<strong>Location Assets Report:</strong> Yol tarifi, telefon araması, web sitesi ziyareti detayları.",
        "<strong>Store Visits Report:</strong> Fiziksel mağaza ziyaretlerini ölçer (Google Location History verisi, %85+ doğruluk).",
        "<strong>Call Reporting:</strong> Telefon aramalarını kaydet, süresini ölç (minimum 60 saniye 'qualified call' sayılır).",
        "<strong>Google Analytics 4 (GA4):</strong> Web sitesi davranış analizi, form doldurmalar, cross-device tracking.",
        "<strong>Google Business Profile Insights:</strong> Profil görüntülenmeleri, arama sorguları, fotoğraf görüntülemeleri."
      ]
    },
    {
      type: "subheading",
      value: "Sektöre Göre Başarı Benchmarks"
    },
    {
      type: "table",
      caption: "Sektörel Başarı Kıyaslamaları (<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> Verileri)",
      headers: ["Sektör", "Ortalama CTR", "Ortalama CPC", "Store Visit Rate", "ROAS"],
      rows: [
        ["Restoran/Kafe", "%8-12", "4-8 TL", "%40-55", "4x-6x"],
        ["Sağlık Hizmetleri", "%6-10", "12-28 TL", "%30-45", "8x-15x"],
        ["Otomotiv Servis", "%7-11", "6-15 TL", "%35-50", "5x-9x"],
        ["Güzellik & SPA", "%9-14", "5-11 TL", "%40-60", "6x-10x"],
        ["Ev Hizmetleri", "%10-18", "5-13 TL", "%25-40", "7x-12x"],
        ["Perakende Mağaza", "%8-13", "3-9 TL", "%45-65", "3x-7x"]
      ]
    },
    {
      type: "paragraph",
      value: "Bu benchmarklar İstanbul ve Ankara gibi büyük şehirler içindir. Küçük illerde CTR %20-30 daha yüksek, CPC %30-40 daha düşük olabilir."
    },
    {
      type: "subheading",
      value: "Optimizasyon İçin Aksiyon Planı"
    },
    {
      type: "paragraph",
      value: "Metriklerinizi düzenli izleyin ve şu aksiyonları alın:"
    },
    {
      type: "list",
      items: [
        "<strong>Haftalık Review:</strong> CTR, CPC, dönüşüm oranlarını her hafta inceleyin, düşük performanslı anahtar kelimeleri durdurun.",
        "<strong>Aylık Derin Analiz:</strong> Store visit rate, ROAS, LTV metriklerini aylık analiz edin, strateji ayarlamaları yapın.",
        "<strong>A/B Testing:</strong> Her ay 2-3 farklı reklam metni, görsel, teklif stratejisi test edin.",
        "<strong>Rakip Analizi:</strong> Auction Insights raporunu inceleyin, rakiplerinizin görünürlüğünü takip edin.",
        "<strong>Sezonsal Ayarlamalar:</strong> Sektörünüzün yoğun sezonlarında bütçeyi %30-50 artırın, durgun sezonda azaltın.",
        "<strong>Coğrafi Optimizasyon:</strong> En iyi performans gösteren mahallelere bütçenin %60-70'ini yönlendirin."
      ]
    },
    {
      type: "paragraph",
      value: "<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">google ads reklam ajansı</a> ile yerel işletmenizi büyütün. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> sektörünüze özel stratejiler oluşturuyor, ölçülebilir sonuçlarla ROI'nizi maksimize ediyorum."
    },
    {
      type: "paragraph",
      value: "<strong>Google Maps Ads</strong>, yerel işletmeler için en yüksek ROI sağlayan dijital pazarlama kanallarından biridir. Doğru kampanya tipi, sektöre özel strateji, detaylı metrik takibi ve sürekli optimizasyon ile işletmenize %400-600 daha fazla fiziksel ziyaret kazandırabilir, gelirlerinizi katlayabilirsiniz. Yerel rekabette lider olmak için hemen bugün Google Maps Ads'e başlayın!"
    }
  ]
};

export default googleMapsAdsContent;
